import React from "react";
import { useNavigate } from "react-router-dom";

const Sidebar = ({ children, handleClick }: any) => {
  const navigate = useNavigate();

  const menus = [{ title: "Tontine", path: "/tontine", icon: "" }];

  const goTo =  (path: string) => {
    navigate('/dahsboard/' + path);
  }

  return (
    <div
      className="absolute h-screen  bg-white  z-50  w-64"
      onClick={handleClick}
    >
      {menus.map((menu, i) => (
        <div key={i} onClick={() => goTo(menu.path) }>
          <span>{menu.title}</span>
        </div>
      ))}
    </div>
  );
};

export default Sidebar;
